import React, { useEffect } from "react";
import { addToCart, removeFromCart } from "../actions/cartActions";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import NavBar from "../components/navbar";
import Footer from "../components/footer";

function CartPage(props) {
  const productId = props.match.params.id;
  const qty = props.location.search
    ? Number(props.location.search.split("=")[1])
    : 1;

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const dispatch = useDispatch();

  const removeFromCartHandler = (productId) => {
    dispatch(removeFromCart(productId));
  };

  useEffect(() => {
    if (productId) {
      dispatch(addToCart(productId, qty));
    }
  }, [dispatch, productId, qty]);

  const checkoutHandler = () => {
    props.history.push("/signin?redirect=shipping");
  };

  return (
    <div>
      <NavBar />
      <div>
        <div className="container  pt-5 mb-1">
          <div className=" d-flex shopping align-items-end">
            <div className="shopping_cart col-6">Shopping Cart</div>
            {/* <div className=" col-4">
              <div className="shopping_price">Price</div>
            </div> */}
          </div>
        </div>

        <div className="container  pt-3 ">
          <div className="row detail ">
            <div className="col col-lg-7  mb-3 listing">
              <ul className="list-unstyled">
                {cartItems.length === 0 ? (
                  <div>Cart is empty</div>
                ) : (
                  cartItems.map((item) => (
                    <div key={item.name}>
                      <li className="d-flex justify-content-between  mb-5">
                        <div className="cart_img ">
                          <img src={item.image} width="150" alt="product" />
                        </div>
                        <div className="cart_info ">
                          <div>
                            <ul className="list-unstyled">
                              <li className="cart_name ">
                                <Link
                                  to={`/products/${item.product}`}
                                  className="text-decoration-none"
                                >
                                  <strong>{item.name}</strong>
                                </Link>
                              </li>
                              <li className="d-flex">
                                Qty:
                                <div>
                                  <select
                                    className="form-select cart-qty "
                                    value={item.qty}
                                    onChange={(e) => {
                                      dispatch(
                                        addToCart(item.product, e.target.value)
                                      );
                                    }}
                                  >
                                    {[...Array(item.countInStock).keys()].map(
                                      (x) => (
                                        <option value={x + 1} key={x + 1}>
                                          {x + 1}
                                        </option>
                                      )
                                    )}
                                  </select>
                                </div>
                              </li>
                              <li className="cart_delete">
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary"
                                  onClick={() =>
                                    removeFromCartHandler(item.product)
                                  }
                                >
                                  Delete
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="cart_price text-end">${item.price}</div>
                      </li>
                    </div>
                  ))
                )}
              </ul>
            </div>
            <div className="col col-lg-4 ">
              <div className="card  order_action">
                <div className="card-body">
                  <div className="subtotal">
                    Subtotal({cartItems.reduce((a, c) => a + Number(c.qty), 0)}
                    items) : $
                    {cartItems.reduce((a, c) => a + c.price * c.qty, 0)}
                  </div>
                  <button
                    href="#"
                    className="btn btn-warning "
                    disabled={cartItems.length === 0}
                    onClick={checkoutHandler}
                  >
                    Proceed to Checkout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default CartPage;

// import React, { useEffect } from "react";
// import { addToCart, removeFromCart } from "../actions/cartActions";
// import { useDispatch, useSelector } from "react-redux";
// import { Link } from "react-router-dom";
// import NavBar from "../components/navbar";
// import Footer from "../components/footer";

// function CartPage(props) {
//   const cart = useSelector((state) => state.cart);
//   // console.log(cart);
//   const { cartItems } = cart;

//   const productId = props.match.params.id;
//   const qty = props.location.search
//     ? Number(props.location.search.split("=")[1])
//     : 1;
//   const dispatch = useDispatch();
//   const removeFromCartHandler = (productId) => {
//     dispatch(removeFromCart(productId));
//   };

//   useEffect(() => {
//     if (productId) {
//       dispatch(addToCart(productId, qty));
//     }
//   }, []);

//   const checkoutHandler = () => {
//     props.history.push("/signin?redirect=shipping");
//   };

//   return (
//     <div>
//       <NavBar />
//       <div>
//         <div className="container  pt-5 mb-1">
//           <div className=" d-flex  col-lg-8 shopping align-items-end">
//             <div className="shopping_cart flex-fill  col-lg-6">
//               Shopping Cart
//             </div>
//             <div className="  col-lg-2 ">
//               <div className="shopping_price">Price</div>
//             </div>
//           </div>
//         </div>

//         <div className="container  pt-3 ">
//           <div className="row details ">
//             <div className="col col-lg-8 mb-3 listing">
//               <ul className="list-unstyled">
//                 {cartItems.length === 0 ? (
//                   <div>Cart is empty</div>
//                 ) : (
//                   cartItems.map((item) => (
//                     <div key={item.name}>
//                       <li className="d-flex  mb-5">
//                         <div className="cart_img col col-lg-3">
//                           <img src={item.image} width="150" alt="product" />
//                         </div>
//                         <div className="cart_info col col-md-6 col-lg-6">
//                           <div>
//                             <ul className="list-unstyled">
//                               <li className="cart_name ">
//                                 <Link
//                                   to={`/products/${item.product}`}
//                                   className="text-decoration-none"
//                                 >
//                                   <strong>{item.name}</strong>
//                                 </Link>
//                               </li>
//                               <li className="d-flex">
//                                 Qty:
//                                 <div>
//                                   <select
//                                     className="form-select cart-qty "
//                                     value={item.qty}
//                                     onChange={(e) => {
//                                       dispatch(
//                                         addToCart(item.product, e.target.value)
//                                       );
//                                     }}
//                                   >
//                                     {[...Array(item.countInStock).keys()].map(
//                                       (x) => (
//                                         <option value={x + 1} key={x + 1}>
//                                           {x + 1}
//                                         </option>
//                                       )
//                                     )}
//                                   </select>
//                                 </div>
//                               </li>
//                               <li className="cart_delete">
//                                 <button
//                                   type="button"
//                                   className="btn btn-outline-secondary"
//                                   onClick={() =>
//                                     removeFromCartHandler(item.product)
//                                   }
//                                 >
//                                   Delete
//                                 </button>
//                               </li>
//                             </ul>
//                           </div>
//                         </div>
//                         <div className="cart_price col col-lg-2 text-end">
//                           ${item.price}
//                         </div>
//                       </li>
//                     </div>
//                   ))
//                 )}
//               </ul>
//             </div>
//           </div>

//           <div className="col col-lg-3  ">
//             <div className="card  order_action">
//               <div className="card-body">
//                 <div className="subtotal">
//                   Subtotal({cartItems.reduce((a, c) => a + Number(c.qty), 0)}
//                   items) : ${cartItems.reduce((a, c) => a + c.price * c.qty, 0)}
//                 </div>
//                 <button
//                   href="#"
//                   className="btn btn-warning "
//                   disabled={cartItems.length === 0}
//                   onClick={checkoutHandler}
//                 >
//                   Proceed to Checkout
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// }

// export default CartPage;
